/**
 * Horas en la unidad que se lee de un golpe.
 *
 * Un recorrido va de minutos a semanas, y decir «312,4 h» obliga a dividir
 * mentalmente por veinticuatro cada vez.
 */
export function duracion(horas: number | null | undefined): string {
  if (horas === null || horas === undefined) return '—'

  if (horas < 1) {
    const minutos = Math.round(horas * 60)

    // «0 min» es una cifra que no se puede afirmar: se lee como
    // «instantáneo», y lo que de verdad se sabe es que fue MENOS de un
    // minuto. La diferencia importa donde la historia viene de una carga
    // inicial, que es justo donde más salía este cero.
    return minutos === 0 ? '< 1 min' : `${minutos} min`
  }

  if (horas < 48) return `${horas.toFixed(1).replace('.', ',')} h`

  const dias = horas / 24
  if (dias < 14) return `${dias.toFixed(1).replace('.', ',')} días`

  return `${Math.round(dias)} días`
}
